import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User clicked to upgrade their plan (opens confirmation modal)',
  name: 'plan_upgrade_modal_clicked',
  params: [
    {
      description: 'Current plan the user is on',
      name: 'old_plan',
      required: true,
      type: 'string',
    },
    {
      description: 'Plan the user is upgrading to',
      name: 'new_plan',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
